import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Avatar,
} from '@mui/material';
import {
  Home as HomeIcon,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Box sx={{ textAlign: 'center' }}>
        <Avatar
          sx={{
            width: 120,
            height: 120,
            mx: 'auto',
            mb: 4,
            backgroundColor: '#f59e0b',
            fontSize: '3rem',
          }}
        >
          404
        </Avatar>
                  <Typography variant="h2" component="h1" sx={{ mb: 2, color: '#64748b' }}>
            Page Not Found
          </Typography>
        <Typography variant="h6" sx={{ mb: 4, color: 'text.secondary' }}>
          The page you're looking for doesn't exist or has been moved.
        </Typography>
        <Button
          variant="contained"
          size="large"
          component={Link}
          to="/"
          startIcon={<HomeIcon />}
          sx={{
            background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
            px: 4,
            py: 1.5,
          }}
        >
          Return Home
        </Button>
      </Box>
    </Container>
  );
};

export default NotFound; 